module.exports = __webpack_public_path__ + "img/fire_red.99232bd1.gif";